module.exports = __webpack_public_path__ + "img/2.17526604.png";